import TextFieldComponent from '@components/inputs/textField/TextField.component';
import ModalComponent from '@components/modal/Modal.component';
import { Colors } from '@constants/colors.constants';
import styled from '@emotion/styled';
import { GreyCheck, ServicesInactive, TimeGrey } from '@icons/index';
import { Close } from '@mui/icons-material';
import CircleIcon from '@mui/icons-material/Circle';
import { Button, CircularProgress, Drawer, IconButton, Stack, Step, Stepper, Typography, alpha } from '@mui/material';
import { useObservable } from '@ngneat/react-rxjs';
import { AuditOfferSupplierLightDto, UpdateAuditProposalSupplierDto } from '@store/audits/audit-offer-followUp/audit-proposal-suppliers/audit-proposal-suppliers.model';
import { auditsProposalSuppliersQuery } from '@store/audits/audit-offer-followUp/audit-proposal-suppliers/audit-proposal-suppliers.query';
import { auditProposalSuppliersServices } from '@store/audits/audit-offer-followUp/audit-proposal-suppliers/audit-proposal-suppliers.services';
import { auditOfferFollowUpQuery } from '@store/audits/audit-offer-followUp/audits-offer-followUp.query';
import copy from 'copy-to-clipboard';
import dayjs from 'dayjs';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { finalize, switchMap } from 'rxjs';
import DetailsStatus from './DetailsStatus.modal';
import OfferTagItem, { OfferStatusEnum } from './OfferTagItem';
import SucceedModal from './SucceedModal';


const Logo = styled('img')`
  object-fit: contain;
  width: 20px;
`;

const LogoContainer = styled(Stack)({
  width: '35px',
  height: '35px',
  borderRadius: '50%',
  backgroundColor: Colors.white,
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: '10px'
});

const LogoContainerGrey = styled(Stack)({
  width: '25px',
  height: '25px',
  borderRadius: '50%',
  backgroundColor: alpha('#868F9C', 0.2),
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: '4px',
  marginRight: '15px',
});

const BoxOffer = styled(Stack)({
  border: '1px solid #E4E6E9',
  borderRadius: '4px',
  padding: '18px 20px',
  justifyContent: 'space-between',
  alignItems: 'center',
  flex: 1,
  marginTop: '26px'
});

const StyledStepper = styled(Stepper)({
  '& .MuiStepConnector-line': {
    borderLeftStyle: 'dashed',
    marginLeft: '4px',
    borderLeftWidth: '2px',
    borderLeftColor: 'rgba(0, 0, 0, 0.12)',
  },
});

const ExpireTag = styled(Stack)({
  backgroundColor: alpha(Colors.error, 0.14),
  borderRadius: '4px',
  padding: '8px 10px',
  alignItems: 'center',
  height: 'fit-content',
  '& svg': {
    width: '15px',
    height: '15px',
    marginRight: '5px',
  },
});

const OfferDetailsStatus = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { offerStatusId, auditId } = useParams();
  const [{ auditsProposalDetails }] = useObservable(auditOfferFollowUpQuery.auditProposalDetails$);
  const [{ auditsProposalSupplierDetails }] = useObservable(auditsProposalSuppliersQuery.auditsProposalSupplierDetails$);
  const createdAt = auditsProposalSupplierDetails?.createdAt ? dayjs(auditsProposalSupplierDetails.createdAt) : null;
  const expireAt = auditsProposalDetails?.expireAt ? dayjs(auditsProposalDetails.expireAt) : null;
  const [openDetails, setOpenDetails] = useState(false);
  const [openSuccedModal, setOpenSuccedModal] = useState(false);
  const textToCopy = t('audits.auditOfferFollowUp.link', { auditProposalSupplierId: offerStatusId });
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [email, setEmail] = useState('');
  const [openModal, setOpenModal] = useState(false);


  useEffect(() => {
    if (auditsProposalSupplierDetails?.email) {
      setEmail(auditsProposalSupplierDetails.email);
    }
  }, [auditsProposalSupplierDetails?.email]);


  const isSameDay = dayjs().isSame(expireAt, 'day');
  const isAfter = dayjs().isAfter(expireAt);
  const isExpired = isAfter && !isSameDay;
  const displayExpiredBadge = isExpired &&
    !auditsProposalSupplierDetails?.validatedAt &&
    !auditsProposalSupplierDetails?.answeredAt &&
    !auditsProposalSupplierDetails?.sentAt;

  const displayBadge = !auditsProposalSupplierDetails?.validatedAt &&
    !auditsProposalSupplierDetails?.answeredAt &&
    !auditsProposalSupplierDetails?.sentAt;

  const historyArray = auditsProposalSupplierDetails?.validatedAt && auditsProposalSupplierDetails?.answeredAt ? [
    { title: 'Proposition traitée', emissionDate: dayjs(auditsProposalSupplierDetails.validatedAt), partner: 'Metawaste' },
    { title: 'Nouvelle réponse', emissionDate: dayjs(auditsProposalSupplierDetails.answeredAt), partner: auditsProposalSupplierDetails.supplierUnit.name },
    { title: 'Nouvelle proposition commerciale', emissionDate: createdAt, partner: 'Metawaste' }
  ] : auditsProposalSupplierDetails?.validatedAt ? [
    { title: 'Proposition traitée', emissionDate: dayjs(auditsProposalSupplierDetails.validatedAt), partner: 'Metawaste' },
    { title: 'Nouvelle proposition commerciale', emissionDate: createdAt, partner: 'Metawaste' }
  ] : auditsProposalSupplierDetails?.answeredAt ? [
    { title: 'Nouvelle réponse', emissionDate: dayjs(auditsProposalSupplierDetails.answeredAt), partner: auditsProposalSupplierDetails.supplierUnit.name },
    { title: 'Nouvelle proposition commerciale', emissionDate: createdAt, partner: 'Metawaste' },
  ] : auditsProposalSupplierDetails?.sentAt ? [
    { title: 'Nouvelle proposition commerciale', emissionDate: createdAt, partner: 'Metawaste' },
  ] : [
    { title: 'Nouvelle proposition commerciale', emissionDate: createdAt, partner: 'Metawaste' }
  ];

  const handleCloseModal = () => setOpenDetails(false);

  const handleEmail = () => {
    if (auditsProposalSupplierDetails?.id && email) {
      auditProposalSuppliersServices.patchAuditsSupEmail(auditsProposalSupplierDetails.id, email).pipe(
        switchMap(() => auditProposalSuppliersServices.getAuditsProposalSupplierDetails(auditsProposalSupplierDetails.id))
      ).subscribe({
        error: (err) => enqueueSnackbar(err.text, err.options),
        complete: () => setOpenModal(false),
      });
    }
  };

  useEffect(() => {
    setLoading(true);
    if (offerStatusId) {
      auditProposalSuppliersServices.getAuditsProposalSupplierDetails(offerStatusId)
        .pipe(finalize(() => setTimeout(() => setLoading(false), 300)))
        .subscribe({
          next(value) { setEmail(value.email); },
        });
    }
  }, [offerStatusId]);

  const handleClose = () => {
    navigate(-1);
  };

  const StatusView = auditsProposalSupplierDetails?.validatedAt ? <OfferTagItem tagStatus={OfferStatusEnum.VALIDATE} /> :
    auditsProposalSupplierDetails?.answeredAt ? <OfferTagItem tagStatus={OfferStatusEnum.ANSWERED} /> :
      auditsProposalSupplierDetails?.sentAt ? <OfferTagItem isDetails tagStatus={OfferStatusEnum.WAITING} /> : null;

  const handleIsPending = () => {
    if (!offerStatusId) return;
    auditProposalSuppliersServices.patchAuditsSupSentAT(offerStatusId)
      .pipe(switchMap(() => auditProposalSuppliersServices.getAuditsProposal(auditId as string, false)))
      .subscribe();
  };

  const handleSucceed = (value: AuditOfferSupplierLightDto[]) => {
    const payload: UpdateAuditProposalSupplierDto = {
      auditOfferSuppliers: value.map((item) => ({
        id: item.id,
        serviceKindId: item.serviceKind?.id,
        unitCostInCents: item.unitCostInCents,
        status: item.status,
      })),
    };

    auditProposalSuppliersServices.patchAuditsOfferSupFromProposalSup(offerStatusId as string, payload)
      .pipe(
        switchMap(() => auditProposalSuppliersServices.getAuditsProposalSupplierDetails(offerStatusId as string)),
        finalize(() => {
          setOpenDetails(false);
          setOpenSuccedModal(true);
        })
      ).subscribe({
        error: (err) => enqueueSnackbar(err.text, err.options),
      });
  };


  const handleOpenModalEmail = () => setOpenModal(true);
  const handleCloseModalEmail = () => {
    setEmail(auditsProposalSupplierDetails?.email || '');
    setOpenModal(false);
  };



  return (
    <Drawer PaperProps={{ sx: { paddingInline: 0 } }} anchor="right" open onClose={handleClose}>
      {loading ? (
        <Stack p="20px" height={'100%'} spacing={4} justifyContent={loading ? 'center' : undefined}>
          <CircularProgress size={40} sx={{ alignSelf: 'center' }} />
        </Stack>
      ) : (
        <>
          <Stack px='20px' mb={'40px'}>
            <Stack direction="row" justifyContent="flex-end">
              <IconButton onClick={handleClose}>
                <Close />
              </IconButton>
            </Stack>
            <Stack>
              <Stack direction="row" alignItems="center" justifyContent="space-between" mb={'25px'}>
                <Typography fontSize={18} fontWeight={700}>
                  {auditsProposalSupplierDetails?.name ?? '-'}
                </Typography>
                {displayExpiredBadge ? (
                  <ExpireTag direction='row'>
                    <Close sx={{ color: Colors.error }} />
                    <Typography fontWeight={400} fontSize='12px' color={Colors.error}>
                      Expiré
                    </Typography>
                  </ExpireTag>)
                  : undefined}
                {displayBadge && !isExpired ? (
                  <Button variant='outlined' sx={{ height: '30px', border: '1px solid', borderColor: Colors.primary }} onClick={() => handleIsPending()}>
                    <Typography fontSize='14px' fontWeight={400} color='#192133' noWrap>
                      Offre remise au partenaire
                    </Typography>
                  </Button>
                ) : undefined}
              </Stack>
              <Stack spacing={1}>
                {[{ title: 'Site', value: auditsProposalSupplierDetails?.clientName || '-' },
                { title: 'Partenaire', value: auditsProposalSupplierDetails?.supplierUnit.name || '-' },
                { title: 'Rédigé le', value: createdAt?.format('DD/MM/YYYY') || '-' },
                { title: 'Date limite', value: expireAt?.format('DD/MM/YYYY') || '-' },
                ].map((item, idx) => (
                  <Stack direction="row" alignItems="center" key={idx}>
                    <Stack maxWidth={'100px'} flex={1}>
                      <Typography fontSize="14px" fontWeight={400} color="#8D95A2">
                        {item.title}
                      </Typography>
                    </Stack>
                    <Typography fontSize="14px" fontWeight={400} color="#192133">
                      {item.value}
                    </Typography>
                  </Stack>
                ))}
                <Stack direction="row" alignItems="center">
                  <Stack maxWidth={'100px'} flex={1}>
                    <Typography fontSize="14px" fontWeight={400} color="#8D95A2">
                      Statut
                    </Typography>
                  </Stack>
                  {StatusView || '-'}
                </Stack>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Stack direction="row" alignItems="center" >
                    <Stack width={'100px'} >
                      <Typography fontSize="14px" fontWeight={400} color="#8D95A2">
                        Email
                      </Typography>
                    </Stack>
                    <Typography fontSize="14px" fontWeight={400} color="#192133">
                      {auditsProposalSupplierDetails?.email || '-'}
                    </Typography>
                  </Stack>
                  <Button variant='contained' color='primary' sx={{ maxWidth: '150px', height: '30px' }} onClick={handleOpenModalEmail}>
                    <Typography fontSize='14px' fontWeight={400} color='#192133' noWrap>
                      Modifier
                    </Typography>
                  </Button>
                </Stack>
                {openModal && (
                  <ModalComponent
                    aria-label="over-drawer"
                    handleClose={handleCloseModalEmail}
                    customColor='#FFFFFF'
                    contentHeight='20vh'
                    contentFullWidth
                    maxWidth="sm"
                    content={
                      <Stack width="100%" height={'100%'} bgcolor='#F4F6F8' justifyContent='center' alignItems='center' >
                        <Stack maxWidth={'350px'} flex={1} justifyContent='center'>
                          <TextFieldComponent
                            labelWidth={80}
                            label="Email"
                            value={email}
                            color="secondary"
                            placeholder='Email du partenaire'
                            handleChange={setEmail}
                          />
                        </Stack>
                        <Button variant='contained' color='primary' sx={{ maxWidth: '150px', height: '30px', marginBottom: '2.5rem' }} onClick={handleEmail}>
                          <Typography fontSize='14px' fontWeight={400} color='#192133' noWrap>
                            Valider
                          </Typography>
                        </Button>
                      </Stack>
                    }
                  />
                )}
              </Stack>
              <BoxOffer direction='row'>
                <Stack direction="column" alignItems="flex-start">
                  <Typography fontSize='14px' fontWeight={400} color='#192133'>
                    Lien de consultation
                  </Typography>
                  <Typography fontSize='12px' fontWeight={400} color={Colors.lightGrey} >
                    {auditsProposalSupplierDetails?.consultUrl ?? textToCopy}
                  </Typography>
                </Stack>
                <Button variant='contained' color='primary' sx={{ maxWidth: '150px', height: '30px' }} onClick={() => copy(auditsProposalSupplierDetails?.consultUrl ?? textToCopy)}>
                  <Typography fontSize='14px' fontWeight={400} color='#192133' noWrap>
                    Copier
                  </Typography>
                </Button>
              </BoxOffer>
              <BoxOffer direction='row'>
                <Typography fontSize='14px' fontWeight={400} color='#192133'>
                  Offre Metawaste
                </Typography>
                <Button
                  variant='contained'
                  color='primary'
                  sx={{ maxWidth: '150px', height: '30px' }} onClick={() => setOpenDetails(true)}>
                  <Typography fontSize='14px' fontWeight={400} color='#192133' noWrap>
                    Consulter l’offre
                  </Typography>
                </Button>
              </BoxOffer>
            </Stack>
          </Stack>
          <Stack spacing={2} bgcolor='#F4F6F8' p="20px 10px 20px 20px" height={'100dvh'}>
            <Typography fontSize='14px' fontWeight={700} color='#192133'>
              Historique
            </Typography>
            <Stack height={'46dvh'} className="scrollable" py={'15px'} pr="10px" overflow="auto" spacing={2.5}>
              <StyledStepper orientation="vertical">
                {historyArray.length > 1 || auditsProposalSupplierDetails?.sentAt ? (
                  <Step>
                    <Stack direction="row" alignItems={'center'}>
                      <LogoContainerGrey>
                        {auditsProposalSupplierDetails?.validatedAt ? <GreyCheck width={10} height={10} /> : <TimeGrey width={10} height={10} />}
                      </LogoContainerGrey>
                      <Stack direction={'column'} flex={1}>
                        <Typography fontSize='12px' fontWeight={400} color={Colors.lightGrey}>
                          {auditsProposalSupplierDetails?.validatedAt ? 'La proposition commerciale a été traitée.' :
                            auditsProposalSupplierDetails?.sentAt && historyArray.length >= 1 ?
                              `L’offre a été remise à ${auditsProposalSupplierDetails?.supplierUnit.name} et est en attente de réponse.`
                              : 'En attente de réponse de votre part'
                          }
                        </Typography>
                      </Stack>
                    </Stack>
                  </Step>
                ) : undefined}
                {historyArray.map((item, idx) => (
                  <Step key={`${item.emissionDate}-${idx}}`}>
                    <Stack direction="row" alignItems={'center'} >
                      <LogoContainer>
                        {item.title.includes('Nouvelle réponse') ? <ServicesInactive width={12} height={12} /> : <Logo alt="metawaste logo" src="/images/metawaste-logo.png" />}
                      </LogoContainer>
                      <Stack direction={'column'} flex={1}>
                        <Typography fontSize='14px' fontWeight={400} color='#192133'>
                          {item.title}
                        </Typography>
                        <Stack direction={'row'} alignItems={'center'} spacing={0.5}>
                          <Typography fontSize='12px' fontWeight={400} color={Colors.lightGrey}>
                            {item.emissionDate?.format('DD/MM/YYYY')}
                          </Typography>
                          <CircleIcon sx={{ height: '5px', width: '5px', color: Colors.lightGrey }} />
                          <Typography fontSize='12px' fontWeight={400} color={Colors.lightGrey}>
                            {item.partner}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Stack>

                  </Step>
                ))}
              </StyledStepper>
            </Stack>
          </Stack>
        </>
      )}
      {
        openDetails ? (
          (auditsProposalSupplierDetails?.validatedAt || auditsProposalSupplierDetails?.answeredAt) ? (
            <DetailsStatus partnerStatusId={offerStatusId} handleClose={handleCloseModal} handleSucceed={handleSucceed} />
          ) : (
            <DetailsStatus partnerStatusId={offerStatusId} isPending handleClose={handleCloseModal} handleSucceed={handleSucceed} />
          )
        ) : null
      }
      {
        openSuccedModal ? (
          <SucceedModal handleClose={() => setOpenSuccedModal(false)} />
        ) : undefined
      }
    </Drawer >
  );
};

export default OfferDetailsStatus;